import * as InstructorGroup from './instructor-group';
import * as PayoutActivation from './payout-activation';
// Standalone
import * as ManageUser from './manage-user';

export const Components = [...InstructorGroup.Components, ...PayoutActivation.Components];

export const Routing = [...InstructorGroup.Routing, ...PayoutActivation.Routing, ...ManageUser.Routing];
